
const Footer = () => {
    return (
        <footer className="bg-dark p-5 text-center text-light">
            <div className="container">
                <div className="d-md-flex justify-content-center align-items-center font-link">
                    <h6>طراحی و تحلیل سیستم و پیاده سازی سایت توسط : CopyRight &copy; <a
                        href="http://www.farzademadi.ir" target="_blank" rel="noreferrer"> <span
                        className="text-decoration-underline fw-bold text-warning">FARZAD EMADI</span></a>
                    </h6>
                </div>
            </div>
        </footer>

    );
}

export default Footer;